export default "__VITE_ASSET__FaVZAVb0__"